import { FunctionComponent } from "react";

import GithubIcon from "../icons/github.svg";
import TwitterIcon from "../icons/twitter.svg";
import LinkedInIcon from "../icons/linkedin.svg";
import YoutubeIcon from "../icons/youtube.svg";

export const SocialLinks: FunctionComponent<{ hideLabels?: boolean }> = ({
  hideLabels,
}) => {
  return (
    <div className="social px-1 md:px-2 my-4 md:my-10 flex flex-wrap gap-4 sm:gap-6 lg:gap-10 text-xs  justify-center md:justify-end  md:absolute md:top-0 md:right-0 md:my-4">
      <a
        href="https://github.com/dejavu1987"
        target="_blank"
        rel="noreferrer"
        className="hover:text-black social-link "
        data-id="GitHub"
      >
        <GithubIcon className="inline w-4 h-4" /> {!hideLabels && "GitHub"}
      </a>
      <a
        href="https://www.youtube.com/@MomoCoder"
        target="_blank"
        rel="noreferrer"
        className="hover:text-red-500 social-link"
        data-id="YouTube"
      >
        <YoutubeIcon className="inline w-4 h-4" /> {!hideLabels && "YouTube"}
      </a>
      <a
        href="https://www.linkedin.com/in/anilmaharjandeveloper/"
        target="_blank"
        rel="noreferrer"
        className="hover:text-blue-500 social-link "
        data-id="LinkedIn"
      >
        <LinkedInIcon className="inline w-4 h-4" /> {!hideLabels && "LinkedIn"}
      </a>
      <a
        href="https://twitter.com/dejavu1987"
        target="_blank"
        rel="noreferrer"
        className="hover:text-sky-500 social-link"
        data-id="Twitter"
      >
        <TwitterIcon className="inline w-4 h-4" /> {!hideLabels && "Twitter"}
      </a>
    </div>
  );
};
